import * as Api from '@ViewModels';
import * as React from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useConnectionTypes } from '../../../../queries';

export function withConnectionTypes<T = any>(
	WrappedComponent: React.ComponentType<T>,
	options: {
		refetchOnWindowFocus: boolean;
	}
) {
	const Sfc: React.FC<T & IConnectionTypeComponentProps> = props => {
		const userSession = useUserSession();
		const connectionTypeQuery = useConnectionTypes({
			enabled: userSession.account.features.connectionTypes?.enabled ?? false,
			refetchOnWindowFocus: options.refetchOnWindowFocus,
		});

		return <WrappedComponent connectionTypes={connectionTypeQuery.data?.availableConnectionTypes ?? []} {...props} />;
	};
	return Sfc;
}

export interface IConnectionTypeComponentProps {
	connectionTypes?: Api.IConnectionType[];
}
